export const PARTICIPANT_STATUSES = {
  ORDERED: 'ordered',
  BOOKED: 'booked',
  CONFIRMED: 'confirmed',
  COMPLETE: 'complete'
};

export const PARTICIPANT_RESULT_STATUSES = {
  IN_PROGRESS: 'in_progress',
  AVAILABLE: 'available'
};

export const PARTICIPANT_CONFIRMED_STATUSES = [PARTICIPANT_STATUSES.CONFIRMED, PARTICIPANT_STATUSES.COMPLETE];

export const FIT_STATUS_OPTIONS = [
  { value: 'fit', label: 'Fit' },
  { value: 'unfit', label: 'Unfit' },
  { value: 'fit_with_notes', label: 'Fit with Notes' },
  { value: 'temporary_unfit', label: 'Temporary Unfit' },
  { value: 'baik', label: 'Baik' },
  { value: 'sedang', label: 'Sedang' },
  { value: 'kurang', label: 'Kurang' }
];

export const FIT_STATUS_LABELS = FIT_STATUS_OPTIONS.reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});

export const SERVICE_ORDER_STATUSES = {
  DRAFT: 'draft',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed'
};
